import { Component, Input, OnInit } from '@angular/core';
import { Login } from '../user.types';

@Component({
  selector: 'b4a-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css']
})
export class LoginFormComponent  {

  @Input()
  login: Login;

  @Input()
  errors: [string];

  @Input()
  onSubmit;

}



// WEBPACK FOOTER //
// ./src/app/users/login-form/login-form.component.ts